/**
 * Features Data — 28 glassmorphism cards (content from design-mockups)
 * IDs are stable — never change after deploy (stored in localStorage)
 *
 * name: short function name (shown in lists, modal title)
 * title: descriptive tagline (shown as subtitle in modal)
 * status: 'available' | 'beta'
 * btnAction/btnArg: window.* handler to call when CTA is clicked (available only)
 * content: array of content blocks rendered in the card
 */

export const FEATURES_DATA = [
 // ===== AVAILABLE =====
 {
 id: 'carte',
 iconName: 'map',
 name: 'Carte collaborative',
 title: 'Planifie avant de partir',
 status: 'available',
 color: '#3b82f6',
 badge: 'Disponible',
 content: [
 { type: 'scenario', text: 'Tu pars pour Lyon demain. Tu zoomes sur les sorties d\'autoroute ce soir. Tu enregistres les 2 meilleurs spots en offline. Demain matin, tu es prêt.' },
 ],
 tags: ['Préparation voyage', 'Enregistrer offline', 'Notes personnelles'],
 btnLabel: 'Je planifie',
 btnAction: 'changeTab',
 btnArg: 'spots',
 },
 {
 id: 'stations',
 iconName: 'fuel',
 name: 'Stations-service',
 title: 'Avant l\'autoroute ou à la sortie ?',
 status: 'available',
 color: '#f97316',
 badge: 'Disponible',
 content: [
 { type: 'steps', color: '#f97316', items: [
 'Active le filtre Stations sur la carte',
 'Vois celles qui sont sur ta route',
 'Choisis la plus stratégique (avant péage = plus de voitures)',
 'Approche naturellement',
 ]},
 ],
 tags: [],
 btnLabel: 'Stratégique',
 btnAction: 'changeTab',
 btnArg: 'spots',
 },
 {
 id: 'add-spot',
 iconName: 'map-pin',
 name: 'Ajouter un spot',
 title: 'Tu passes le flambeau',
 status: 'available',
 color: '#10b981',
 badge: 'Disponible',
 content: [
 { type: 'quote', text: '"J\'ai mis 6h à trouver comment sortir de São Paulo. J\'ai ajouté le spot. Le prochain mettra 20 minutes. C\'est le deal."' },
 { type: 'sub', text: '3 minutes pour ajouter un spot. Des dizaines de voyageurs épargnent des heures de galère. Pour des années.' },
 ],
 tags: [],
 btnLabel: 'J\'ajoute mon spot',
 btnAction: 'openAddSpot',
 },
 {
 id: 'profil',
 iconName: 'user',
 name: 'Profil voyageur',
 title: 'Ton identité de voyageur',
 status: 'available',
 color: '#8b5cf6',
 badge: 'Disponible',
 content: [
 { type: 'sub', text: 'Photo, bio, langues, pays visités, réseaux sociaux. Pas un profil de réseau social, un profil de routard.' },
 ],
 tags: ['Photo de profil', 'Langues parlées', 'Pays visités', 'Bio voyage'],
 btnLabel: 'Voir mon profil',
 btnAction: 'changeTab',
 btnArg: 'profile',
 },
 {
 id: 'amis',
 iconName: 'handshake',
 name: 'Amis',
 title: 'Retrouve ceux que tu as croisés sur la route',
 status: 'available',
 color: '#ec4899',
 badge: 'Disponible',
 content: [
 { type: 'sub', text: 'Tu as rencontré quelqu\'un à un spot ou dans une voiture. Vous vous ajoutez. Vous restez en contact pour vos prochains voyages.' },
 ],
 tags: ['Demande d\'ami', 'Profil complet', 'Voyages communs', 'Messages privés'],
 btnLabel: 'Ajouter des amis',
 btnAction: 'changeTab',
 btnArg: 'social',
 },
 {
 id: 'chat',
 iconName: 'message-circle',
 name: 'Chat par pays',
 title: 'Un canal par pays. Des infos ciblées.',
 status: 'beta',
 color: '#06b6d4',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { emoji: '🇬🇷', title: 'Rejoins le canal de ton pays', desc: 'Tu arrives en Grèce ? Rejoins le canal Grèce. Les dernières infos des gens sur place.' },
 { iconName: 'map-pin', title: 'Messages épinglés', desc: 'Les infos essentielles en haut. Pas besoin de scroller 500 messages.' },
 { iconName: 'bell', title: 'Notifs ciblées', desc: 'Notifié uniquement sur les pays qui t\'intéressent. Pas de bruit sur le reste.' },
 ]},
 ],
 tags: ['Réponses rapides', 'Communauté mondiale', '24/7', '4 langues'],
 },
 {
 id: 'carnet',
 emoji: '',
 name: 'Carnet de voyage',
 title: 'Public ou privé, tu choisis',
 status: 'available',
 color: '#a855f7',
 badge: 'Disponible',
 content: [
 { type: 'sub', text: 'Certains lifts, tu veux les partager avec tes amis. D\'autres sont rien qu\'à toi. Contrôle ligne par ligne ce qui est visible.' },
 ],
 tags: ['Privé par défaut', 'Partage sélectif', 'Amis uniquement', 'Profil public'],
 btnLabel: 'Je contrôle',
 btnAction: 'changeTab',
 btnArg: 'voyage',
 },
 {
 id: 'stats',
 iconName: 'bar-chart-3',
 name: 'Statistiques',
 title: 'Turquie : 2 300 km. 14 lifts. 18 min d\'attente moyenne.',
 status: 'beta',
 color: '#3b82f6',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { iconName: 'globe', title: 'Stats par pays', desc: 'Tes stats détaillées par pays. Chaque pays que tu as traversé en stop.' },
 { iconName: 'bar-chart-3', title: 'Compare les pays', desc: 'Temps d\'attente, distance, nombre de lifts. Tu compares les pays entre eux.' },
 { iconName: 'trophy', title: 'Ton meilleur pays', desc: '"Ton meilleur pays : la Roumanie. 8 min d\'attente en moyenne." Info utile pour le prochain voyage.' },
 ]},
 ],
 tags: ['Par année', 'Par pays', 'Comparatif mois'],
 },
 {
 id: 'classements',
 iconName: 'trophy',
 name: 'Classements',
 title: 'Contribue. Monte. Sois vu.',
 status: 'beta',
 color: '#eab308',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { iconName: 'trophy', title: 'Classements hebdo', desc: 'Classements hebdo par pays et mondial. Les meilleurs contributeurs en haut.' },
 { iconName: 'medal', title: 'Ligues et saisons', desc: 'Badges de saison, ligues, classement amis. Du fun qui motive à contribuer.' },
 { iconName: 'globe', title: 'La carte grandit', desc: 'Plus tu contribues, plus la carte est utile. Le classement, c\'est le bonus.' },
 ]},
 ],
 tags: ['Chaque semaine un nouveau leader', 'Tu peux être là'],
 },
 {
 id: 'niveaux',
 iconName: 'trending-up',
 name: 'Niveaux et badges',
 title: 'Tes badges disent qui tu es sans un mot.',
 status: 'beta',
 color: '#f59e0b',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { iconName: 'user', title: 'Ton profil parle', desc: 'Quelqu\'un regarde ton profil. Il voit : 15 pays, Niveau 22, badge "Routard des Balkans".' },
 { iconName: 'handshake', title: 'Confiance immédiate', desc: 'Il sait immédiatement que tu es expérimenté(e). Il te fait confiance pour voyager ensemble.' },
 { iconName: 'map-pin', title: 'Tes spots pèsent', desc: 'Tes spots sont pris plus au sérieux. Un spot posé par un Niveau 22, ça pèse plus.' },
 ]},
 ],
 tags: [],
 btnLabel: 'Mes badges',
 btnAction: 'openBadges',
 },
 {
 id: 'conseils',
 iconName: 'lightbulb',
 name: 'Conseils par pays',
 title: '1 phrase. C\'est tout ce qu\'il faut.',
 status: 'available',
 color: '#84cc16',
 badge: 'Disponible',
 content: [
 { type: 'highlight', title: ' Un conseil utile = une phrase', desc: '"En Albanie, commence tôt le matin." Voilà. C\'est un conseil utile. Tu n\'as pas besoin d\'écrire un roman.' },
 ],
 tags: [],
 btnLabel: 'Facile',
 btnAction: 'showGuides',
 },
 {
 id: 'dons',
 iconName: 'heart',
 name: 'Dons',
 title: 'Sois parmi les premiers à soutenir',
 status: 'available',
 color: '#fbbf24',
 badge: 'Disponible',
 content: [
 { type: 'highlight', title: ' Pourquoi donner ?', desc: 'SpotHitch est libre et sans pub. Pas de paywall. Juste des autostoppeurs qui s\'entraident. Un don garde ça vivant.' },
 { type: 'sub', text: 'Au nom de tous ceux qui voyagent sans moyen de donner.' },
 ],
 tags: [],
 btnLabel: 'Rejoindre',
 btnAction: 'openDonation',
 },
 {
 id: 'hors-ligne',
 iconName: 'wifi-off',
 name: 'Mode hors-ligne',
 title: 'Télécharge avant de partir',
 status: 'available',
 color: '#22c55e',
 badge: 'Disponible',
 content: [
 { type: 'steps', color: '#22c55e', items: [
 'Va dans Profil → Réglages → Données hors-ligne',
 'Choisis un ou plusieurs pays',
 'Téléchargement en quelques secondes',
 'Disponible même en mode avion',
 ]},
 ],
 tags: [],
 btnLabel: 'Comment faire',
 btnAction: 'openSettings',
 },
 {
 id: 'sos',
 iconName: 'siren',
 name: 'SOS d\'urgence',
 title: '3 taps. Tes proches savent.',
 status: 'beta',
 color: '#ef4444',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { iconName: 'siren', title: 'Bouton SOS intégré', desc: 'Position GPS envoyée par SMS à tes contacts de confiance.' },
 { iconName: 'phone', title: 'Tout est prévu', desc: 'Faux appel, alerte silencieuse, enregistrement discret.' },
 { iconName: 'wifi-off', title: 'Toujours disponible', desc: 'Fonctionne hors-ligne. Fonctionne partout. Fonctionne toujours.' },
 ]},
 ],
 tags: ['3 pressions', 'SMS + GPS', 'Offline', 'Même sans parler'],
 btnLabel: 'Configurer maintenant',
 btnAction: 'openSOS',
 },

 // ===== BETA =====
 {
 id: 'compagnon',
 iconName: 'handshake',
 name: 'Compagnon de route',
 title: 'Même direction ? Partons ensemble.',
 status: 'beta',
 color: '#8b5cf6',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { iconName: 'map', title: 'Même destination', desc: 'Trouve quelqu\'un qui va au même endroit, aux mêmes dates.' },
 { iconName: 'user', title: 'Profils vérifiés', desc: 'Avis d\'autres voyageurs. Tu sais à qui tu as affaire.' },
 { iconName: 'handshake', title: 'Le stop à deux', desc: 'Plus sûr, plus fun, plus rapide.' },
 ]},
 ],
 tags: ['Match par destination', 'Date flexible', 'Profil vérifié'],
 btnLabel: 'Ça m\'intéresse',
 },
 {
 id: 'notif-spot',
 iconName: 'bell',
 name: 'Alertes spot proche',
 title: 'Tu passes à côté d\'un spot. 30 secondes pour aider.',
 status: 'beta',
 color: '#f59e0b',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { iconName: 'map-pin', title: 'Détection automatique', desc: 'L\'app détecte que tu es à 200m d\'un spot qui n\'a pas été vérifié depuis longtemps.' },
 { emoji: '', title: 'Un tap suffit', desc: 'Confirme : "oui, ce spot existe encore". C\'est tout.' },
 { iconName: 'medal', title: '+5 points', desc: 'Tu as rendu la carte plus fiable pour le prochain voyageur. En 30 secondes.' },
 ]},
 ],
 tags: ['Alerte intelligente', 'Seulement si tu veux', '+5 points'],
 btnLabel: 'Bonne idée',
 },
 {
 id: 'activite-amis',
 iconName: 'users',
 name: 'Activité amis',
 title: 'Jour 1 : Barcelone. Jour 3 : Marseille. Jour 5 : Rome.',
 status: 'beta',
 color: '#3b82f6',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { iconName: 'book-open', title: 'Carnet de route live', desc: 'Suis le voyage de ton ami étape par étape. Comme un carnet de route en temps réel.' },
 { iconName: 'map-pin', title: 'Chaque étape visible', desc: 'Chaque spot posé, chaque pays traversé. Tu vois exactement par où il passe.' },
 { iconName: 'message-circle', title: 'Commente les étapes', desc: 'Tu peux commenter ses étapes. "Attends, t\'es passé par Split ? Faut que je te raconte."' },
 ]},
 ],
 tags: [],
 btnLabel: 'Exactement ça',
 },
 {
 id: 'defis',
 iconName: 'medal',
 name: 'Défis',
 title: ' Routard des Balkans',
 status: 'beta',
 color: '#f97316',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlight', title: 'Conditions du badge', desc: 'Hitche en Serbie, Croatie, Bosnie, Albanie et Monténégro. Dans n\'importe quel ordre.' },
 { type: 'sub', text: 'Tu voyages dans la région ? C\'est le moment de décrocher ce badge.' },
 ],
 tags: [],
 btnLabel: 'Je vise ce badge',
 },
 {
 id: 'score-confiance',
 iconName: 'shield-check',
 name: 'Score de confiance',
 title: 'Ton score, c\'est ta réputation de voyageur.',
 status: 'beta',
 color: '#059669',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { iconName: 'trophy', title: 'Confiance méritée', desc: 'Un bon score, ça veut dire que la communauté te fait confiance. C\'est gratifiant.' },
 { iconName: 'trending-up', title: 'Chaque action compte', desc: 'Chaque spot ajouté, chaque aide dans le chat, chaque bon avis fait monter ton score.' },
 { iconName: 'users', title: 'Cercle vertueux', desc: 'Plus ton score est haut, plus les gens veulent voyager avec toi.' },
 ]},
 ],
 tags: ['Profil vérifié', 'Historique voyage', 'Avis communauté'],
 btnLabel: 'Important pour moi',
 },
 {
 id: 'avis-profils',
 iconName: 'message-circle',
 name: 'Avis profils',
 title: 'Vous avez voyagé ensemble. Raconte comment c\'était.',
 status: 'beta',
 color: '#ec4899',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { emoji: '', title: 'Laisse un avis', desc: 'Après un voyage partagé, tu laisses un avis. Quelques phrases suffisent.' },
 { iconName: 'handshake', title: 'Évaluation mutuelle', desc: 'L\'autre fait pareil. Vous vous évaluez mutuellement, en toute transparence.' },
 { iconName: 'globe', title: 'Aide les suivants', desc: 'Tes avis aident les futurs voyageurs à savoir à qui ils ont affaire.' },
 ]},
 ],
 tags: [],
 btnLabel: 'Je comprends',
 },
 {
 id: 'itineraire',
 iconName: 'compass',
 name: 'Itinéraire',
 title: 'Ta destination. Ta route. Spot par spot.',
 status: 'beta',
 color: '#10b981',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { iconName: 'map-pin', title: 'Route optimale', desc: 'Entre ta destination. L\'app calcule la route via les meilleurs spots.' },
 { iconName: 'fuel', title: 'Tout sur ta route', desc: 'Stations-service, sorties d\'autoroute, tout est sur ta route.' },
 { iconName: 'wifi-off', title: 'Voyage sans internet', desc: 'Télécharge tout. Voyage sans internet.' },
 ]},
 ],
 tags: [' Spots 4★+', ' Stations', ' Offline'],
 btnLabel: 'J\'en ai besoin',
 },
 {
 id: 'radar',
 iconName: 'radio',
 name: 'Radar de proximité',
 title: 'Qui est autour de toi ? Active le radar.',
 status: 'beta',
 color: '#06b6d4',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { iconName: 'radio', title: 'Temps réel', desc: 'Vois les autostoppeurs proches en temps réel. Contacte-les directement.' },
 { iconName: 'lock', title: '100% privé', desc: 'Tu actives quand tu veux, tu coupes quand tu veux.' },
 { iconName: 'handshake', title: 'Ensemble', desc: 'Se rejoindre, partager un lift, ou juste savoir qu\'on n\'est pas seul.' },
 ]},
 ],
 tags: ['Radar ON/OFF', 'Message direct', 'Vie privée protégée'],
 btnLabel: 'J\'active le radar',
 },
 {
 id: 'quiz',
 iconName: 'brain',
 name: 'Quiz',
 title: '"Quel geste signifie stop en Grèce ?" Tu le sais ?',
 status: 'beta',
 color: '#6366f1',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { emoji: '', title: 'Questions utiles', desc: 'Des questions utiles pour le voyage. Pas de la culture générale random. Du concret.' },
 { iconName: 'lightbulb', title: 'Apprends en jouant', desc: 'Chaque bonne réponse t\'apprend quelque chose. "En Grèce, le pouce levé est une insulte."' },
 { iconName: 'globe', title: 'Découvre avant de partir', desc: 'Tu découvres des pays avant d\'y aller. Mieux préparé, moins de surprises.' },
 ]},
 ],
 tags: [],
 btnLabel: 'Je veux le streak',
 },
 {
 id: 'guides',
 iconName: 'book-open',
 name: 'Guides par pays',
 title: 'Le guide du stop. Par pays. Par des stoppeurs.',
 status: 'beta',
 color: '#84cc16',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { iconName: 'globe', title: 'Chaque pays couvert', desc: 'Comment fonctionne le stop dans chaque pays. Les astuces que seuls les voyageurs connaissent.' },
 { emoji: '', title: 'Par la communauté', desc: 'Écrit et mis à jour par la communauté. Du vécu, pas du copié-collé.' },
 { iconName: 'shield-check', title: 'Tout en un endroit', desc: 'Sécurité, culture locale, mots utiles, erreurs à éviter.' },
 ]},
 ],
 tags: [],
 btnLabel: 'C\'est ça que je veux',
 },
 {
 id: 'gardien',
 iconName: 'shield-check',
 name: 'Mode gardien',
 title: 'Quelqu\'un veille. Toujours.',
 status: 'beta',
 color: '#3b82f6',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { iconName: 'map-pin', title: 'Position live', desc: 'Position live partagée avec tes gardiens. Automatique, silencieux, privé.' },
 { emoji: '⏰', title: 'Check-in régulier', desc: 'Si tu ne réponds plus, alerte envoyée.' },
 { emoji: '', title: 'Arrivée notifiée', desc: 'Notification d\'arrivée automatique. Personne ne s\'inquiète pour rien.' },
 ]},
 ],
 tags: [],
 btnLabel: 'Activer le Gardien',
 },
 {
 id: 'evenements',
 iconName: 'party-popper',
 name: 'Événements',
 title: 'La communauté se retrouve. En vrai.',
 status: 'beta',
 color: '#eab308',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { emoji: '', title: 'Meetups et courses', desc: 'Meetups, courses de stop, festivals. Organisés par la communauté, pour la communauté.' },
 { emoji: '', title: 'Crée un événement', desc: 'Crée un événement n\'importe où. Les voyageurs proches sont notifiés.' },
 { iconName: 'handshake', title: 'Rencontres de voyage', desc: 'Les meilleures amitiés du voyage commencent par une rencontre. On en crée les occasions.' },
 ]},
 ],
 tags: ['Créer un événement', 'Rejoindre', 'Agenda communauté'],
 btnLabel: 'Voir les événements',
 },
 {
 id: 'auberges',
 iconName: 'building',
 name: 'Auberges',
 title: 'Les auberges testées par des routards. Pas par des algorithmes.',
 status: 'beta',
 color: '#f97316',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { iconName: 'backpack', title: 'Sélection communautaire', desc: 'Notées par des voyageurs comme toi, pas par des touristes.' },
 { iconName: 'map-pin', title: 'Sur ta route', desc: 'Liées à ta route. Proches des spots de stop. Pratiques pour repartir le matin.' },
 { iconName: 'coins', title: 'Budget routard', desc: 'Filtrées par budget routard. Pas de resort à 80€ la nuit dans les résultats.' },
 ]},
 ],
 tags: ['Sélection communautaire', 'Note autostoppeur', 'Avis vrais', 'Critères route'],
 btnLabel: 'Voir la sélection',
 },
 {
 id: 'villes',
 iconName: 'building-2',
 name: 'Guides villes',
 title: 'T\'arrives dans une ville que tu connais pas. Et pourtant, t\'es prêt.',
 status: 'beta',
 color: '#14b8a6',
 badge: 'Arrive bientôt',
 content: [
 { type: 'highlights', items: [
 { iconName: 'map-pin', title: 'Spots par direction', desc: 'Spots de sortie classés par direction avec les avis des voyageurs. Tu sais déjà où aller demain matin.' },
 { iconName: 'moon', title: 'Infos pratiques', desc: 'Où dormir pas cher, quoi manger, comment se déplacer. Les infos qu\'on cherche tous en arrivant.' },
 { iconName: 'wifi-off', title: 'Tout hors-ligne', desc: 'Tout dispo sans internet. Tu atterris dans une ville à minuit sans data ? T\'as quand même tout.' },
 ]},
 ],
 tags: ['428 villes', 'Par direction', 'Hors-ligne'],
 },
]

// Map for O(1) lookup by id
export const FEATURES_MAP = Object.fromEntries(FEATURES_DATA.map(f => [f.id, f]))
